import React, { Fragment } from 'react'
import TicketsPriceType from './tickets-price-type'

function IllinoisPriceType({ priceType, illinois, hitMaximumsByAge, noPrice }) {
  return (
    <Fragment>
      <TicketsPriceType
        priceType={priceType}
        emptyBody
        last
        hitMaximumsByAge={hitMaximumsByAge}
        noPrice={noPrice}
      />

      <TicketsPriceType
        priceType={priceType}
        priceKey={illinois ? 'illinois' : 'chicago'}
        last
        nested
        useLabel
        hitMaximumsByAge={hitMaximumsByAge}
        noPrice={noPrice}
      />

      <TicketsPriceType
        priceType={priceType}
        last
        nested
        useLabel
        hitMaximumsByAge={hitMaximumsByAge}
        noPrice={noPrice}
        ruled
      />
    </Fragment>
  )
}

export default IllinoisPriceType
